//------------------------
// get filter status desc
//------------------------
export default function getRefilterStatus(cur_filter_status_ind) {

  if (cur_filter_status_ind == false) {
    return "Inactive"
  } else {
    return "Active"
  }
}